import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @const FieldGroupsShortenedQuery
 * @since 1.0.0
 */
export const FieldGroupsShortenedQuery = gql `
  query FieldGroupsQuery($input: FieldGroupsInput) {
    fieldGroups(input: $input) {
      id
      category

      fields {
        id
        name
        value
        title
        infos
        type
        promote
        useInQueryBuilder
        options

        group {
          id
          category
        }

        translations {
          id
          title
          infos
          createdAt
          updatedAt

          language {
            ...LanguageFragment
          }
        }
      }
    }
  }
  ${LanguageFragment}
`;
